<template>
  <Layout>
    <PageHeader :title="page_title" :items="items"/>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <Loader :loading="httpSend">
            <div class="card-body">
              <form-wizard ref="tabPessoa"
                           next-button-text="Próximo"
                           back-button-text="Anterior"
                           color="#556ee6">
                <tab-content :before-change="validaTabPessoaJuridica" title="Dados da Empresa" icon="bx bx-user">
                  <div class="row">
                    <div class="col-12">
                      <b-form>
                        <div class="row">
                          <div class="col-md-4">
                            <b-form-group label="CNPJ" label-for="pesf_cpfcnpj">
                              <input class="form-control"
                                     v-mask="'##.###.###/####-##'"
                                     v-model="pessoa.tps_cpf_cnpj"
                                     :class="{ 'is-invalid': $v.pessoa.tps_cpf_cnpj.$error || cpfCnpjInvalid }"
                                     v-on:focusout="locEmpresaWeb(pessoa.tps_cpf_cnpj)"
                                     id="pesf_cpfcnpj" type="text">
                              <div v-if="$v.pessoa.tps_cpf_cnpj.$error" class="invalid-feedback">
                                Informe o CNPJ
                              </div>
                              <div v-show="cpfCnpjInvalid" class="invalid-feedback">
                                CNPJ Inválido
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-5">
                            <b-form-group label="Razão Social" label-for="tps_razao_social_nome">
                              <input class="form-control"
                                     maxlength="200"
                                     v-model="pessoa.tps_razao_social_nome"
                                     :class="{ 'is-invalid': $v.pessoa.tps_razao_social_nome.$error }"
                                     id="tps_razao_social_nome" type="text">
                              <div v-if="$v.pessoa.tps_razao_social_nome.$error" class="invalid-feedback">
                                Informe a razão social
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Data de Abertura" label-for="tps_data_abertura_nascimento">
                              <input v-model="pessoa.tps_data_abertura_nascimento" id="tps_data_abertura_nascimento"
                                     :class="{ 'is-invalid': $v.pessoa.tps_data_abertura_nascimento.$error }"
                                     type="date" class="form-control"/>
                              <div v-if="$v.pessoa.tps_data_abertura_nascimento.$error" class="invalid-feedback">
                                Informe a data de abertura
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <b-form-group label="Nome Fantasia" label-for="tps_nome_fantasia">
                              <input class="form-control"
                                     maxlength="200"
                                     :class="{ 'is-invalid': $v.pessoa.tps_nome_fantasia.$error }"
                                     v-model="pessoa.tps_nome_fantasia" id="tps_nome_fantasia" type="text">
                              <div v-if="$v.pessoa.tps_nome_fantasia.$error" class="invalid-feedback">
                                Informe o nome fantasia
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-8">
                            <b-form-group label="Natureza Jurídica" label-for="tps_natureza_juridica">
                              <multiselect
                                  v-model="pessoa.tps_natureza_juridica"
                                  :class="{'is-invalid': $v.pessoa.tps_natureza_juridica.$error }"
                                  placeholder="Selecione a Natureza Jurídica"
                                  :custom-label="labelNaturezaJuridica"
                                  track-by="naj_codigo"
                                  openDirection="bottom"
                                  :options="tab_selecoes.natureza_juridica"
                                  :close-on-select="true"
                                  :show-labels="false">
                                <template slot="option" slot-scope="props">
                                  <div class="option__desc">
                                    <span class="option__title">[{{
                                        props.option.naj_referencia
                                      }}] {{ props.option.naj_descricao }}</span>
                                  </div>
                                </template>
                              </multiselect>
                              <div v-if="$v.pessoa.tps_natureza_juridica.$error" class="invalid-feedback">
                                Informe a natureza jurídica
                              </div>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-4">
                            <b-form-group label="Tributação Especial" label-for="tps_tributacao">
                              <select id="tps_tributacao" v-model="pessoa.tps_tributacao"
                                      :class="{'is-invalid': $v.pessoa.tps_tributacao.$error }"
                                      class="custom-select"
                                      type="text">
                                <option value=""></option>
                                <option value="1">Microempreendedor Individual (MEI)</option>
                                <option value="2">Empresa Simples Nacional</option>
                                <!-- Ainda será definido como o ISS é cobrado
                                <option value="3">Estimativo</option>
                                <option value="4">Sociedade de Profissionais</option>
                                <option v-if="tps_tipo === 4" value="5">Cooperativas</option>
                                -->
                                <option value="6">Sem Tributação Especial</option>
                              </select>
                              <div v-if="$v.pessoa.tps_tributacao.$error" class="invalid-feedback">
                                Selecione o tipo de tributação
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-4">
                            <b-form-group label="Porte" label-for="tps_porte">
                              <select id="tps_porte" v-model="pessoa.tps_porte"
                                      class="custom-select"
                                      type="text">
                                <option value=""></option>
                                <option value="1">Microempreendedor Individual (MEI)</option>
                                <option value="2">Microempresa (ME)</option>
                                <option value="3">Empresa de Pequeno Porte (EPP)</option>
                                <option value="4">Empresa de Médio Porte</option>
                                <option value="99">Demais</option>
                              </select>
                            </b-form-group>
                          </div>
                          <div class="col-md-4">
                            <b-form-group label="Tipo de Estabelecimento" label-for="tps_tipo_estabelecimento">
                              <select id="tps_tipo_estabelecimento" v-model="pessoa.tps_tipo_estabelecimento"
                                      class="custom-select" type="text">
                                <option value=""></option>
                                <option value="1">Matriz</option>
                                <option value="2">Filial</option>
                                <option value="3">Representação</option>
                                <option value="4">Caixa Eletrônico</option>
                                <option value="5">Torre Transmissão</option>
                                <option value="6">Depósito/Almoxarifado</option>
                                <option value="7">Garagem</option>
                                <option value="8">Posto de Coleta</option>
                                <option value="9">Ponto Quiosque/Exposição</option>
                                <option value="10">Ponto Outdoor/Publicidade</option>
                                <option value="99">Outros</option>
                              </select>
                            </b-form-group>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-3">
                            <b-form-group label="Início das atividades no município" label-for="tps_data_inicio">
                              <input v-model="pessoa.tps_data_inicio" id="tps_data_inicio"
                                     :class="{ 'is-invalid': $v.pessoa.tps_data_inicio.$error }"
                                     type="date" class="form-control"/>
                              <div v-if="$v.pessoa.tps_data_inicio.$error" class="invalid-feedback">
                                Informe a data de início das atividades no município
                              </div>
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Inscrição Municipal" label-for="tps_inscricaomunicipal">
                              <input class="form-control"
                                     maxlength="50"
                                     v-model="pessoa.tps_inscricaomunicipal" id="tps_inscricaomunicipal"
                                     type="text">
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Inscrição Estadual" label-for="tps_inscricao_estadual">
                              <input class="form-control"
                                     maxlength="50"
                                     v-model="pessoa.tps_inscricao_estadual" id="tps_inscricao_estadual"
                                     type="text">
                            </b-form-group>
                          </div>
                          <div class="col-md-3">
                            <b-form-group label="Capital Social" label-for="tps_capital_social">
                              <money class="form-control"
                                     v-model="pessoa.tps_capital_social" v-bind="money"></money>
                            </b-form-group>
                          </div>
                        </div>
                      </b-form>
                    </div>
                  </div>
                </tab-content>
                <tab-content :before-change="validaTabContato" :lazy="true" title="Contato" icon="bx bx-phone-call">
                  <ContatoSolicitacoes
                      :telefone_tipo="tab_selecoes.telefone_tipo"
                      :list_email="lista_email"
                      :list_telefone="lista_telefone">
                  </ContatoSolicitacoes>
                </tab-content>
                <tab-content :before-change="validaTabEndereco" :lazy="true" title="Endereço" icon="bx bx-envelope">
                  <EnderecoSolicitacoes
                      :pessoa="pessoa"
                      :endereco_tipo="tab_selecoes.endereco_tipo"
                      :list_endereco="lista_endereco">
                  </EnderecoSolicitacoes>
                </tab-content>
                <tab-content :before-change="validaTabFiscal" :lazy="true" title="Dados Fiscais"
                             icon="bx bx-book-bookmark">
                  <FiscalJuridicoSolicitacoes
                      :tps_tipo="tps_tipo"
                      :list_cnae="list_cnae"
                      :list_servicos="list_servicos"
                      @resetarListServicos="list_servicos = $event"
                      :up_contador="contador">
                  </FiscalJuridicoSolicitacoes>
                </tab-content>
                <tab-content v-if="temSocio" :before-change="validaTabSocio" :lazy="true" title="Sócios"
                             icon="bx bx-briefcase-alt">
                  <SociosAdministradores
                      :qualificadores="list_qualificadores_socio"
                      :ecomonico="economico"
                      :list_socio="list_socios"
                      v-on:update:list_socio="list_socios = $event">
                  </SociosAdministradores>
                </tab-content>
                <tab-content v-if="tps_tipo === 6" :before-change="validaTabTabeliao" :lazy="true" title="Tabelião"
                             icon="bx bx-award">
                  <Tabeliao
                      :ecomonico="economico"
                      :tabeliao="tabeliao"
                      v-on:update:tabeliao="tabeliao = $event">
                  </Tabeliao>
                </tab-content>
                <tab-content title="Confirmação" :lazy="true" icon="bx bx-check-double">
                  <ConfirmacaoSolicitacoes>
                  </ConfirmacaoSolicitacoes>
                </tab-content>
                <template slot="footer" scope="props">
                  <div class=wizard-footer-left>
                    <wizard-button v-if="props.activeTabIndex > 0" @click.native="props.prevTab()"
                                   :style="props.fillButtonStyle"><i class="fas fa-arrow-left"></i> Anterior
                    </wizard-button>
                  </div>
                  <div class="wizard-footer-right">
                    <wizard-button v-if="!props.isLastStep" @click.native="props.nextTab()" class="wizard-footer-right"
                                   :style="props.fillButtonStyle">Próximo <i class="fas fa-arrow-right"></i>
                    </wizard-button>
                    <button v-if="props.isLastStep && !pessoa.tem_solicitacao" type="button"
                            @click="confirmacao(1)"
                            class="wizard-footer-right btn btn-label btn-success"><i
                        class="bx bx-check-double label-icon"></i>
                      Enviar Solicitação
                    </button>
                    <button v-if="props.isLastStep && !pessoa.tem_solicitacao" type="button"
                            @click="confirmacao('R')"
                            class="wizard-footer-right finish-button btn btn-label btn-light mr-3">
                      <i class="bx bx-save label-icon"></i>
                      Salvar em Rascunho
                    </button>
                  </div>
                </template>
              </form-wizard>
            </div>
          </Loader>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import {Money} from 'v-money'
import Multiselect from 'vue-multiselect'
import Loader from "@/components/widgets/loader";
import Layout from "../../layouts/main";
import appConfig from "@/dados/app.config.json";
import PageHeader from "@/components/page-header";
import {FormWizard, TabContent, WizardButton} from "vue-form-wizard";
import {getTabSelecoes, getNaturezaQualificacao} from "@/api/geral/helps";
import {required} from "vuelidate/lib/validators";
import {
  getSolicitacao,
  setCecPessoaJuridica,
  setCecContato,
  setCecEndereco,
  setCecConfirmacao, setCecCnaeServico
} from "@/api/solicitacao/pessoa"
import ContatoSolicitacoes from "@/router/views/contribuinte/components/contato-solicitacoes"
import EnderecoSolicitacoes from "@/router/views/contribuinte/components/endereco-solicitacoes"
import FiscalJuridicoSolicitacoes from "@/router/views/contribuinte/components/fiscal-juridico-solicitacoes"
import SociosAdministradores from "@/router/views/contribuinte/components/socios-administradores"
import Tabeliao from "@/router/views/contribuinte/components/tabeliao"
import ConfirmacaoSolicitacoes from "@/router/views/contribuinte/components/confirmacao-solicitacoes"
import {geraHashObjeto, geraHashObjetoIgual, validaCpfCnpj} from "@/helps/util";
import Swal from "sweetalert2";
import store from "@/state/store";
import {locEmpresa} from "@/api/externa/apiExt";

export default {
  page: {
    title: "Pessoa Física",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    Multiselect,
    Money,
    Loader,
    PageHeader,
    FormWizard,
    TabContent,
    WizardButton,
    ContatoSolicitacoes,
    EnderecoSolicitacoes,
    FiscalJuridicoSolicitacoes,
    SociosAdministradores,
    Tabeliao,
    ConfirmacaoSolicitacoes
  },
  props: {
    page_title: {
      type: String,
      required: true,
    },
    tps_tipo: {
      type: Number,
      required: true,
    }
  },
  data() {
    return {
      title: "Solicitação - Pessoa Juridica",
      items: [
        {
          text: 'Painel',
          href: '/painel',
        },
        {
          text: 'Solicitação',
          href: '/contribuinte/solicitacao',
        },
        {
          text: 'Pessoa Física',
          active: true,
        },
      ],
      money: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        precision: 2
      },
      httpSend: false,
      temSocio: false,
      pessoa: {
        tps_codigo: null,
        tps_cpf_cnpj: "",
        tps_razao_social_nome: "",
        tps_nome_fantasia: "",
        tps_data_abertura_nascimento: null,
        tps_data_inicio: null,
        tps_inscricao_estadual: "",
        tps_inscricaomunicipal: "",
        tps_porte: null,
        tps_tipo_estabelecimento: null,
        tps_natureza_juridica: null,
        tps_capital_social: 0.00,
        tps_tributacao: "",
        tps_tipo: null,
        tem_solicitacao: false
      },
      tab_selecoes: {
        natureza_juridica: [],
        telefone_tipo: [],
        endereco_tipo: []
      },
      lista_email: [],
      lista_telefone: [],
      lista_endereco: [],
      list_cnae: [],
      list_servicos: [],
      list_qualificadores_socio: [],
      contador: {},
      economico: {
        tec_codigo: null,
        tec_contador: null,
        tec_contador_proprio: null,
        tec_protocolo: null,
        tec_tabeliao: null,
        tps_codigo: null
      },
      list_socios: [],
      tabeliao: {
        tps_cpf_cnpj: '',
        tet_codigo_comercial: '',
      },
      hashPessoa: "",
      hashContato: "",
      hashEndereco: "",
      cpfCnpjInvalid: false,
    };
  },
  validations: {
    pessoa: {
      tps_cpf_cnpj: {
        required,
      },
      tps_razao_social_nome: {
        required,
      },
      tps_data_abertura_nascimento: {
        required,
      },
      tps_data_inicio: {
        required,
      },
      tps_nome_fantasia: {
        required,
      },
      tps_natureza_juridica: {
        required,
      },
      tps_tributacao: {
        required,
      }
    }
  },
  created() {
    this.tabSelecoes();
    if (this.$route.params.tps_hash) {
      this.getSocilitacao();
    } else {
      this.pessoa.tps_tipo = this.tps_tipo;
    }
  },
  methods: {
    labelNaturezaJuridica({naj_referencia, naj_descricao}) {
      return `[${naj_referencia}] ${naj_descricao}`
    },
    tabSelecoes() {
      getTabSelecoes(2).then(response => {
        this.tab_selecoes.natureza_juridica = response.dados.natureza_juridica;
        this.tab_selecoes.endereco_tipo = response.dados.endereco_tipo;
        this.tab_selecoes.telefone_tipo = response.dados.telefone_tipo;
      }).catch(error => {
        console.log(error);
      })
    },
    getSocilitacao() {
      this.httpSend = true;
      getSolicitacao(this.$route.params.tps_hash).then(response => {
        if (response.status) {
          this.pessoa = response.dados.pessoa;
          this.naturezaQualificacao();
          this.pessoa.tps_tipo = parseInt(this.pessoa.tps_tipo);
          this.hashPessoa = geraHashObjeto(this.pessoa);
          this.lista_email = response.dados.emails;
          this.lista_telefone = response.dados.telefones;
          this.hashContato = geraHashObjeto({lista_email: this.lista_email, lista_telefone: this.lista_telefone});
          this.lista_endereco = response.dados.enderecos;
          this.hashEndereco = geraHashObjeto(this.lista_endereco);
          this.economico = response.dados.economico;
          if (this.economico) {
            this.contador = {
              pes_codigo: this.economico.contador,
              proprio_contador: (this.economico.tec_contador_proprio && this.economico.tec_contador_proprio === 'S'),
              pes_nome: (this.economico.contador && this.economico.contador.pes_nome) ? this.economico.contador.pes_nome : null,
              pes_crc: (this.economico.contador && this.economico.contador.pes_crc) ? this.economico.contador.pes_crc : null,
            }
          }
          this.list_cnae = response.dados.cnae;
          this.list_servicos = response.dados.servicos;
          this.list_socios = response.dados.socio;
          const tabeliao = response.dados.tabeliao;
          if (tabeliao) {
            const tabeliao_telefone = response.dados.tabeliao_telefone;
            tabeliao_telefone.forEach(function (t) {
              if (t.tet_codigo.tab_numero === 1) {
                tabeliao.tet_codigo_celular = t.tfo_numero;
                tabeliao.tfo_codigo_celular = t.tfo_codigo;
              }
              if (t.tet_codigo.tab_numero === 2) {
                tabeliao.tet_codigo_comercial = t.tfo_numero;
                tabeliao.tfo_codigo_comercial = t.tfo_codigo;
              }
            });
            this.tabeliao = tabeliao;
          } else {
            this.tabeliao = {
              tps_razao_social_nome: null
            }
          }
        }
      }).catch(error => {
        console.log(error);
      }).finally(() => {
        this.httpSend = false;
      })
    },
    async locEmpresaWeb(cpf_cnpj) {
      return new Promise(resolve => {
        this.httpSend = true
        locEmpresa(cpf_cnpj).then(result => {
          if (Object.prototype.hasOwnProperty.call(result.data, 'cnpj_raiz')) {
            const empresaWeb = result.data;
            this.pessoa.tps_razao_social_nome = empresaWeb.razao_social
            this.pessoa.tps_data_abertura_nascimento = empresaWeb.estabelecimento.data_situacao_cadastral
            this.pessoa.tps_nome_fantasia = empresaWeb.estabelecimento.nome_fantasia
            this.pessoa.tps_natureza_juridica = this.tab_selecoes.natureza_juridica.find(el => el.naj_codigo === empresaWeb.natureza_juridica.id);
            //empresaWeb.natureza_juridica.id
            //empresaWeb.porte
            //empresaWeb.estabelecimento.tipo
            this.pessoa.tps_data_inicio = empresaWeb.estabelecimento.data_inicio_atividade
            this.pessoa.tps_capital_social = empresaWeb.capital_social
            resolve(true);
          } else {
            resolve(false)
          }
        }).catch(error => {
          resolve(false);
          console.log(error)
        }).finally(() => {
          this.httpSend = false
        })
      })
    },
    validaTabPessoaJuridica() {
      this.cpfCnpjInvalid = false;

      this.$v.$reset()
      this.$v.$touch();
      if (this.$v.$invalid) {
        return false;
      }

      this.naturezaQualificacao();

      if (validaCpfCnpj(this.pessoa.tps_cpf_cnpj)) {
        return new Promise((resolve) => {
          this.httpSend = true;
          setCecPessoaJuridica(this.pessoa).then(response => {
            if (response.status) {
              this.pessoa = response.dados;
              this.hashPessoa = geraHashObjeto(this.pessoa);
              resolve(true)
            } else {
              this.$toast.error(response.mensagem);
              resolve(false)
            }
          }).catch(error => {
            this.$toast.error(error);
            resolve(false)
          }).finally(() => {
            this.httpSend = false
          })
        })
      } else {
        this.cpfCnpjInvalid = true;
        return false;
      }
    },
    validaTabContato: function () {
      if (this.lista_email.length > 0 && this.lista_telefone.length > 0) {
        if (this.pessoa.tem_solicitacao) {
          return true;
        }
        if (geraHashObjetoIgual({
          lista_email: this.lista_email,
          lista_telefone: this.lista_telefone
        }, this.hashContato)) {
          return true;
        }
        return new Promise((resolve) => {
          this.httpSend = true;
          setCecContato({
            pessoa: this.pessoa,
            email: this.lista_email,
            telefone: this.lista_telefone
          }).then(response => {
            if (response.status) {
              this.lista_email = response.dados.emails;
              this.lista_telefone = response.dados.telefones;
              this.hashContato = geraHashObjeto({lista_email: this.lista_email, lista_telefone: this.lista_telefone});
              resolve(true)
            } else {
              this.$toast.error(response.mensagem);
              resolve(false)
            }
          }).catch(error => {
            this.$toast.error(error);
            resolve(false)
          }).finally(() => {
            this.httpSend = false
          })
        })
      } else {
        return false
      }
    },
    validaTabEndereco: function () {
      if (this.lista_endereco.length > 0 && this.lista_endereco.length > 0) {
        if (this.pessoa.tem_solicitacao) {
          return true;
        }
        if (geraHashObjetoIgual(this.lista_endereco, this.hashEndereco)) {
          return true;
        }
        return new Promise((resolve) => {
          this.httpSend = true;
          setCecEndereco({
            pessoa: this.pessoa,
            endereco: this.lista_endereco
          }).then(response => {
            if (response.status) {
              this.lista_endereco = response.dados;
              this.hashEndereco = geraHashObjeto(this.lista_endereco);
              resolve(true)
            } else {
              this.$toast.error(response.mensagem);
              resolve(false)
            }
          }).catch(error => {
            this.$toast.error(error);
            resolve(false)
          }).finally(() => {
            this.httpSend = false
          })
        })
      } else {
        return false
      }
    },
    validaTabFiscal: function () {
      if (this.pessoa.tem_solicitacao) {
        return true;
      }

      if (this.list_cnae.length > 0) {
        if (parseInt(this.pessoa.tps_tipo) === 5 || this.tps_tipo === 5) {
          let contabilidade = this.list_cnae.findIndex(x => x.cnae_codigo === '6920601' && x.tpc_principal === true)
          if (contabilidade < 0) {
            return false
          }
        }
      }

      if (parseInt(this.pessoa.tps_tipo) === 4 || this.tps_tipo === 4) {
        if (store.getters['solicitacao/cnaeTemServicos']) {
          return false
        }
      } else {
        if (this.list_servicos && this.list_servicos.length < 1) {
          return false
        }
      }
      if (this.list_cnae && this.list_cnae.length > 0) {
        return new Promise((resolve) => {
          this.httpSend = true;
          setCecCnaeServico({
            pessoa: this.pessoa,
            economico: this.economico,
            cnaes: this.list_cnae,
            servicos: this.list_servicos,
            contador: this.contador
          }).then(response => {
            if (response.status) {
              this.economico = response.dados.economico;
              this.list_servicos = response.dados.servicos;
              resolve(true)
            } else {
              this.$toast.error(response.mensagem);
              resolve(false)
            }
          }).catch(error => {
            this.$toast.error(error);
            resolve(false)
          }).finally(() => {
            this.httpSend = false
          })
        })
      } else {
        return false
      }
    },
    validaTabSocio: function () {
      return this.list_socios && this.list_socios.length > 0;
    },
    validaTabTabeliao: function () {

      return !!this.tabeliao.tps_razao_social_nome;
    },
    isLastStep() {
      if (this.$refs.tabPessoa) {
        return this.$refs.tabPessoa.isLastStep
      }
      return false
    },
    naturezaQualificacao() {
      if (this.pessoa.tps_natureza_juridica) {
        if (this.pessoa.tps_natureza_juridica.tem_socio) {
          let tsocio = parseInt(this.pessoa.tps_natureza_juridica.tem_socio);
          this.temSocio = (tsocio > 0);
          if (this.temSocio) {
            getNaturezaQualificacao(this.pessoa.tps_natureza_juridica.naj_codigo).then(response => {
              if (response.status) {
                this.list_qualificadores_socio = response.dados;
              }
            }).catch(error => {
              console.log(error);
            })
          }
        }
      }
    },
    confirmacao: function (chm_status) {
      if (chm_status === 'R') {
        this.enviaSolicitacao(chm_status);
      } else {
        Swal.fire({
          title: "Enviar solicitação?",
          text: "",
          icon: "question",
          showCancelButton: true,
          confirmButtonColor: "#34c38f",
          cancelButtonColor: "#100e0e",
          confirmButtonText: "Sim",
          cancelButtonText: "Não"
        }).then(result => {
          if (result.isConfirmed) {
            this.enviaSolicitacao(chm_status);
          } else {
            return chm_status;
          }
        });
      }
    },
    enviaSolicitacao(chm_status) {
      this.httpSend = true;
      setCecConfirmacao({
        pessoa: this.pessoa,
        situacao: {chm_status: chm_status},
      }).then(response => {
        if (response.status) {
          this.$toast.success(response.mensagem)
          this.$router.push({name: 'contribuinte-solicitacao'})
        } else {
          this.$toast.error(response.mensagem);
        }
      }).catch(error => {
        this.$toast.error(error);
      }).finally(() => {
        this.httpSend = false
      })
    }
  }
};
</script>
<style>
.option__title {
  word-wrap: break-word;
  white-space: normal;
}
</style>
